'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    sendForm: {
      position: 'relative',
      boxSizing: 'border-box',
      '&.hidden': {
        display: 'none'
      },
      '&.disabled': {
        opacity: theme.disabledOpacity,
        cursor: 'default'
      },
      '& .user': {
        color: theme.primaryColor,
        padding: '0 2px',
        borderRadius: 4,
        display: 'inline-block',
        fontWeight: 600,
        height: 20
      }
    },
    input: {
      'word-break': 'break-word',
      paddingTop: 8,
      paddingBottom: 0,
      minHeight: 60
    },
    chat: {
      paddingTop: 4,
      borderTop: '1px solid ' + theme.sendForm.borderColor,
      '& .field': {
        borderBottom: 0,
        cursor: 'text'
      },
      '&.error': {
        borderTop: '1px solid ' + theme.errorColor
      }
    },
    comment: {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: theme.sendForm.borderColor,
      borderRadius: theme.sendForm.borderRadius,
      padding: '0 12px 12px 12px',
      '& .field': {
        borderBottom: 0,
        cursor: 'text'
      },
      '&.focus': {
        border: '1px solid ' + theme.sendForm.active.borderColor
      },
      '&.error': {
        border: '1px solid ' + theme.errorColor
      }
    },
    artifacts: {
      display: 'flex'
    },
    rating: {
      cursor: 'pointer',
      '& span': {
        marginRight: 8
      },
      '& span:last-child': {
        marginRight: '0 !important'
      }
    },
    controls: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row',
      position: 'relative'
    },
    controlsBtn: {
      '& div': {
        marginLeft: 8
      }
    },
    controlsIcons: {
      display: 'flex',
      '& .fill': {
        fill: theme.sendForm.iconFill
      }
    },
    controlsIconsItem: {
      marginRight: 16,
      cursor: 'pointer',
      position: 'relative'
    },
    usersList: {
      transformOrigin: 'left bottom 0',
      position: 'absolute',
      bottom: 98,
      width: '100%',
      maxWidth: '100%',
      maxHeight: 200,
      '&.hidden': {
        transformOrigin: 'left bottom 0'
      }
    }
  };
};